import React from "react";
import { useState, useMemo, useEffect } from "react";
import ListTable from "../../utils/Table";
import MultiStepForm from "../../utils/MultiStepForm";
import { TableData } from "./TableData";
import ViewChange from "../../utils/ViewChange";
import { FormStructure } from "./FormStructure";

import {
  all_product_list,
  product_create,
  product_update
} from "../../../actions/product";
import { all_category_list } from "./../../../actions/Masters/category";
import { useDispatch, useSelector } from "react-redux";
import Export from "../../utils/Export";
import Import from "../../utils/Import";
import { useRef } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useLocation, useNavigate } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Form from "../../utils/Form";
import { all_unit_list } from "../../../actions/Masters/unit";

export default function Product() {
  const user = useSelector((state) => state.layout.profile);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [openAdError, setOpenAdError] = useState(false);

  const [content, setPopupContent] = useState("");
  const [view, setView] = useState(location?.state?.view || "view_all");
  const [isEdit, setIsEdit] = useState(false);
  const [errorFields, setErrorFields] = useState({});
  const categories = useSelector((state) => state.masters.categories);
	const units = useSelector((state) => state.masters.units);
  const [tableData, setTableData] = useState({
    ...TableData(),
    // deleteRecord: movie_delete,
    onDeleteText: [
      "Are you sure want to delete this Product ?",
      // "The Customer Will not be able to see this video once you delete it.",
    ],
		disableDelete: true,
    
    customisedStatusUpdateMessage: true,
    onActiveText: "Are you sure want to Activate the Product ?",
    onInactiveText: [
      "Are you sure want to Inactivate the Product ?",
      // "The Customer Will not be able to see this video once you Inactivate it.",
    ],
    updateRecord: product_update,
  });

  const [form, setForm] = useState(
    (location?.state?.form && JSON.parse(location?.state?.form)) || {}
  );
  const tempFormStruct = FormStructure(isEdit);
  const [formStructure, setFormStructure] = useState([...tempFormStruct]);
  // const [open1, setOpen1] = useState(false);

  const [formTitle, setFormTitle] = useState(["Add Product"]);
  const path = location?.pathname.split("/")[2];
const products = useSelector((state)=>state?.products?.products)
// console.log(products,"newProducr")
  useEffect(() => {
    setView(path != "Product" ? "create_new" : "view_all");
    setForm(
      (location?.state?.form && JSON.parse(location?.state?.form)) || {status: "Active"}
    );
    setIsEdit(path == "EditProduct");
  }, [location]);


// console.log(form,"newForm!@3")

useEffect(() => {
  // dispatch(all_category_list());
  dispatch(all_unit_list());
  dispatch(all_product_list())
}, []);
  useMemo(() => {
  	if (products?.statuscode == 200) {
  		const temp = tableData;

  		temp.tableBody = products?.data.map((value, index) => ({
  			...value,
  			selling_price: parseFloat(value.selling_price).toFixed(2),
  			price: parseFloat(value.price).toFixed(2),
  			cost: parseFloat(value.cost).toFixed(2),
        // product_category : value?.product_category.category_name,
        unit_of_measure : value?.unit_of_measure.unit_name

  		}));

  		setTableData({ ...temp });
  		setForm({ ...form });
  	}
  }, [products]);


  

  // useMemo(() => {
  //   if (categories?.statuscode == 200) {
  //     const temp = formStructure;
  //     temp[2]["options"] = categories?.data.map(
  //       (category) => category?.category_name
  //     );

  //     setFormStructure([...temp]);
  //   }
  // }, [categories]);
  useMemo(() => {
    if (units?.statuscode == 200) {
      const temp = formStructure;
      temp[1]["options"] = units?.data.map(
        (units) => units?.unit_name
      );

      setFormStructure([...temp]);
    }
  }, [units]);


 

  const message = useSelector((state) => state.layout.message);
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData();

      const temp_product_category = form;

      // temp_product_category["tempproduct_category"] = form?.["product_category"];
      temp_product_category["tempunit_of_measure"] = form?.["unit_of_measure"];

      // temp_product_category["product_category"] = categories?.data
      // 	.map(
      // 		(option) =>
      // 			form?.["product_category"]?.includes(option.category_name) && option.id
      // 	)
      // 	.filter((e) => e);
        temp_product_category["unit_of_measure"] = units?.data
      	.map(
      		(option) =>
      			form?.["unit_of_measure"]?.includes(option.unit_name) && option.id
      	)
      	.filter((e) => e);
  
        temp_product_category["created_by"] = user?.id;
      setForm({
      	...temp_product_category,
      });
      Object.keys(form).map((key) => data.append(key, form?.[key]));
      const temp_form1 = form;
      temp_form1["product_category"] = form?.["tempproduct_category"];
      temp_form1["unit_of_measure"] = form?.["tempunit_of_measure"];

      setForm({
      	...temp_form1,
      });
      const temp = tableData;
      if (isEdit) {
      	dispatch(product_update(data));
      } else {
      	dispatch(product_create(data));
      }
    
  };
  useMemo(() => {
    if (message?.statuscode == 200) {
      setIsEdit(false);

      setForm({});
      setTimeout(() => {
        // const data = new FormData();
        // data.append("id", user?.id);
        dispatch(all_product_list());
        navigate("/Product/Product", { state: { view: "view_all" } });
        setView("view_all");
      }, 900);
    } else {
      setForm({ ...form , status: "Active",})
    }
  }, [message]);
  const videoEl = useRef(null);
  const handleLoadedMetadata = () => {
    const video = videoEl.current;
    var d = Number(video.duration);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);

    var hDisplay = h > 9 ? h : "0" + h + ":";
    var mDisplay = m > 9 ? m : "0" + m + ":";
    var sDisplay = s > 9 ? s : "0" + s;

    setForm({ ...form, movie_duration: hDisplay + mDisplay + sDisplay });
  };

  const handleClose = () => {
    setOpenAdError(false);
  };

  // useMemo(() => {
  // 	// if (movies?.statuscode !== 200) {
  // 	setOpen1(true)
  // 	// }
  // 	// else {
  // 	setTimeout(() => {
  // 		setOpen1(false)
  // 	}, 1000)
  // 	// }
  // }, [tableData.filterColumn?.[1]?.default])

  return (
    <>
      {/* <Backdrop
				sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}

				open={open1}
			>
				<CircularProgress color="inherit" />
			</Backdrop> */}
      <video
        style={{ display: "none" }}
        id="myvid"
        src={form?.movieMp4_URL}
        ref={videoEl}
        type="video/mp4"
        onLoadedMetadata={handleLoadedMetadata}
      ></video>

      <ViewChange
        setForm={setForm}
        setView={setView}
        setIsEdit={setIsEdit}
        view={view}
        isEdit={isEdit}
        create_new={"/Product/CreateProduct"}
        view_all={"/Product/Product"}
        form={form}
        export_excel={
          <Export
            fileName={"Product"}
            isClubed={true}
            exportData={tableData?.exportData || tableData?.tableBody}
            headings={tableData.tableHead.map((value) => value.label)}
          />
        }
        import_excel={<Import module_name="video" isClubed={true} />}
      />

      {view == "create_new" && (
        <Form
          formStructure={formStructure}
          handleSubmit={handleSubmit}
          formTitle={formTitle}
          key={"Form"}
          setForm={setForm}
          form={form}
          tableData={tableData}
          setTableData={setTableData}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
        />
      )}
      {view == "view_all" && (
        <ListTable
          tableData={tableData}
          key={"ListTable"}
          setForm={setForm}
          setTableData={setTableData}
          setIsEdit={setIsEdit}
          create_new={"/Product/EditProduct"}
        />
      )}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={openAdError}
        autoHideDuration={1500}
        onClose={handleClose}
      >
        <Alert severity="info" variant="filled" color="success">
          {content}
        </Alert>
      </Snackbar>
    </>
  );
}
